import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import "../Form-Dialog/form-dialog.scss";
import "./projectSearchArchive.scss"
import Axios from "axios";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { toast } from "react-toastify";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";

function FormDialog(props) {

    const [open, setOpen] = React.useState(false);
    const [reasonForArchive, setReasonForArchive] = useState("");
    const [projectLost, setProjectLost] = useState("");

    function stopPropagation(event) {
        event.stopPropagation()
    }

    function handleClickOpen(event) {
        event.stopPropagation()
        setOpen(true);
    }

    function handleClose(event) {

        setOpen(false);
    }

    async function archiveThisProject() {
        if (projectLost !== "" && reasonForArchive !== "") {
            let setThisProjectAsArchiveAPIUrl = props.APIUrl + "/projects/archive"

            let data = {
                projectId: props.projectId,
                archived: 1,
                archival_reason: reasonForArchive,
                project_lost: projectLost
            }
            let setThisProjectAsArchiveAPIResponse = await Axios.post(setThisProjectAsArchiveAPIUrl, data)
            props.reRenderSearchResults()
            toast.success(translator("Project Search", "archive_success"), {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            handleClose()
        } else {
            let error_message = projectLost === ""
                ? translator("Misc", "archival_won_lost_error")
                : translator("Misc", "archival_reason_error")
            ;
            toast.error(error_message, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    }

    return (
        <div onClick={stopPropagation}>
            <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                <Translated section="Misc" label="archive_label" />
			</Button>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title set-price-dialog-header">
                    {/* Set Project Pricing{" "} */}
                    <Button id="set-price-close-button" onClick={handleClose} color="primary">
                        <i class="fa fa-window-close fa-2x" aria-hidden="true" />
                    </Button>
                </DialogTitle>
                <DialogContent>
                    <div class="form-group">
                        <label><Translated section="Misc" label="archival_dialog_reason" /></label>
                        <input
                            type="text"
                            class="form-control settings-form archive-input-field"
                            onChange={event =>
                                setReasonForArchive(event.target.value)
                            }
                            value={reasonForArchive}
                        />
                    </div>

                    <div class="form-group">
                        <h3 className="WLHeader" ><Translated section="Misc" label="archival_dialog_won_lost" /></h3>
                        <label className="WLLabel" ><Translated section="Misc" label="won_label" /></label>
                        <input
                            onChange={event => setProjectLost(0)}
                            className="WLCheckbox"
                            type="radio"
                            name="WLRadio"
                        />
                        <label className="WLLabel"><Translated section="Misc" label="lost_label" /></label>
                        <input
                            onChange={event => setProjectLost(1)}
                            className="WLCheckbox"
                            type="radio"
                            name="WLRadio"
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={archiveThisProject} color="primary">
                        <Translated section="Misc" label="confirm_btn" />
					</Button>
                    <Button onClick={handleClose} color="primary">
                        <Translated section="Misc" label="close_btn" />
					</Button>

                </DialogActions>
            </Dialog>
        </div>
    );
}

const mapStateToProps = state => ({
    APIUrl: state.APIUrl

});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
